import React, { useState, useEffect, useMemo } from 'react';
import { Styles } from '../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import axios from 'axios';
import { defaultVariabls } from '../../../config/index';
import { withRouter } from 'react-router-dom';
import { withSnackbar } from 'notistack';
import { setStore } from 'trim-redux';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Translate } from '../../../config/Translate';
import { debounce } from 'lodash';

const ProductChooser = ({ classes, inPut, id, outPut }) => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true); // Start with loading
    const [input, setInput] = useState(inPut || '');
    const [defaults, setDefaults] = useState(null);

    useEffect(() => {
        setInput(inPut);
    }, [inPut]);

    useEffect(() => {
        fetchProducts(); // Initial fetch without a query
    }, []);

    useEffect(() => {
        if (input) {
            debouncedFetchProducts(input);
        }
    }, [input]);

    const fetchProducts = async (query = '') => {
        setLoading(true);
        const loginToken = localStorage.getItem('ACT');
        if (!loginToken) {
            setStore({ isAuth: false, user: null, loading: false });
            setLoading(false);
            return;
        }

        try {
            const config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`,
                },
            };
            const data = new FormData();
            data.append('search', query);
            data.append('id', id || 0);

            const response = await axios.post(
                `${defaultVariabls.url}/products/quickViewForAutoComplete`,
                data,
                config
            );

            setProducts(response.data);
            if (inPut) {
                const defaultProduct = response.data.find((product) => product.id === inPut);
                if (defaultProduct) {
                    setDefaults(defaultProduct);
                    outPut(defaultProduct);
                }
            }
        } catch (error) {
            console.error('Error fetching products:', error.response);
        } finally {
            setLoading(false);
        }
    };

    const debouncedFetchProducts = useMemo(() => debounce(fetchProducts, 500), []);

    const handleInputChange = (event, value) => {
        setInput(value);
        debouncedFetchProducts(value);
    };

    const handleChange = (event, value) => {
        outPut(value);
    };

    return (
        <>
            <Autocomplete
                options={products}
                className="autoCompleteHolder"
                onChange={handleChange}
                defaultValue={defaults}
                loading={loading}
                getOptionLabel={(option) => `${option.name} ${option.unique_code} (${Translate[option.physically]} ${option.situation === "worked" ? (" - "+Translate.worked) : ""})`}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={Translate.chooseProductForComment}
                        variant="outlined"
                        fullWidth
                        onChange={(event) => handleInputChange(event, event.target.value)}
                    />
                )}
            />
        </>
    );
};

export default withSnackbar(withRouter(withStyles(Styles)(ProductChooser)));
